import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServiciosPage from "../pages/servicios/page";
import BlogPage from "../pages/blog/page";
import ContactoPage from "../pages/contacto/page";
import EquipoPage from "../pages/equipo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicios",
    element: <ServiciosPage />,
  },
  {
    path: "/equipo",
    element: <EquipoPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/contacto",
    element: <ContactoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
